var AVOID_SELECTOR = '.main-product__shop-bar, .main-product__shop-bar-content';
var AVOID_MIN_OVERLAP = 12;
var AVOID_TAIL_MS = 600;

function plMeasureAvoidOffset() {
  var offset = 0;
  var nodes;
  try {
    nodes = document.querySelectorAll(AVOID_SELECTOR);
  } catch (e) {
    return 0;
  }
  for (var i = 0; i < nodes.length; i++) {
    var el = nodes[i];
    var c = getComputedStyle(el);
    if (c.display === 'none' || c.visibility === 'hidden' || c.opacity === '0') continue;
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) continue;
    var visible = Math.min(window.innerHeight, r.bottom) - Math.max(0, r.top);
    if (visible < AVOID_MIN_OVERLAP) continue;
    if (visible > offset) offset = visible;
  }
  return Math.round(offset);
}

var plOpticalNudge = 1; // px positivos deslocam o botão para a direita

function plFindChatAnchor() {
  // Vellor/Atendia (chat de atendimento, terceiro) tem prioridade quando existe
  // — e o mesmo bubble que este arquivo sempre alinhou. Na loja onde ele esta
  // desligado (enable_chat=false) o elemento nem existe, e o back-to-top ficava
  // sem referencia nenhuma: sem a bolha, plAlignBackToTop() saia no primeiro
  // `if` e o botao nunca era reposicionado, sobrando na posicao padrao do CSS,
  // que pode ficar atras do widget de WhatsApp. Medido em 24/08 no atacado
  // (Atendia desligado, WhatsApp ligado).
  return document.getElementById('vellor-chat-bubble') || document.querySelector('.whatsapp-float');
}

function plAlignBackToTop() {
  var btt = document.querySelector('back-to-top');
  var chat = plFindChatAnchor();
  if (!btt || !chat) return;
  var chatRect = chat.getBoundingClientRect();
  var bttRect = btt.getBoundingClientRect();
  var gap = 16;
  var rightOffset = window.innerWidth - chatRect.right + (chatRect.width - bttRect.width) / 2 - plOpticalNudge;
  var chatBasedBottom = window.innerHeight - chatRect.top + gap;
  var avoidOffset = plMeasureAvoidOffset();
  var avoidBasedBottom = avoidOffset > 0 ? avoidOffset + gap : 0;
  var finalBottom = Math.max(chatBasedBottom, avoidBasedBottom);
  btt.style.right = rightOffset + 'px';
  btt.style.bottom = finalBottom + 'px';
}

var plTailUntil = 0;
function plPump() {
  plAlignBackToTop();
  if (performance.now() < plTailUntil) requestAnimationFrame(plPump);
}
function plSchedule() {
  plTailUntil = performance.now() + AVOID_TAIL_MS;
  requestAnimationFrame(plPump);
}

plAlignBackToTop();
window.addEventListener('load', plAlignBackToTop);
window.addEventListener('resize', plSchedule);
window.addEventListener('orientationchange', plSchedule);
window.addEventListener('scroll', plSchedule, { passive: true });

var plChatEl = plFindChatAnchor();
if (plChatEl) {
  new MutationObserver(plSchedule).observe(plChatEl, { attributes: true, attributeFilter: ['style', 'class'] });
  new ResizeObserver(plSchedule).observe(plChatEl);
}
// O WhatsApp so existe no DOM depois do proprio script dele rodar (mesmo
// <script defer> do tema, ordem de carregamento nao garantida em relacao a
// este arquivo) — se nao achou nenhuma ancora agora, tenta de novo apos o load.
if (!plChatEl) {
  window.addEventListener('load', function () {
    var el = plFindChatAnchor();
    if (!el) return;
    new MutationObserver(plSchedule).observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
    new ResizeObserver(plSchedule).observe(el);
    plAlignBackToTop();
  });
}
new MutationObserver(plSchedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });